import React from 'react';

import { createReactRenderer } from '../helpers/react-renderer';
import { SENSITIVE_INFO_WARNING_ADD_LINK } from 'root/merchantos/utils';

import { openAddSavedCardModal } from './index';

let modalLinkCount = 0;

const AddSavedCardModalLink = ({ customerId }: { customerId: string }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    openAddSavedCardModal({
      customerId,
      onComplete: () => {
        // Refresh the page or trigger any necessary updates after card is added
        window.location.reload();
      },
    });
  };

  return (
    <a href="#" onClick={handleClick}>
      {SENSITIVE_INFO_WARNING_ADD_LINK}
    </a>
  );
};

// Function to render the AddSavedCardModalLink into a DOM element
// This can be used from non-React contexts like utils.ts
export const renderAddSavedCardModalLink = (container: HTMLElement, customerId: string) => {
  // Create a unique selector for this container using global counter
  modalLinkCount += 1;
  const uniqueId = `add-saved-card-link-${modalLinkCount}`;
  container.id = uniqueId;

  const RenderedComponent = createReactRenderer({
    component: AddSavedCardModalLink,
    selector: `#${uniqueId}`,
  });
  RenderedComponent.mount({ props: { customerId } });
  return RenderedComponent;
};

export default AddSavedCardModalLink;
